
export const clearErrors = () => async (dispatch) => {
    dispatch( {type: 'EMPTY_ERROR_REDUCER'});
};